/* eslint-disable jira/filename-case */
export const QUERY_PARAM_SEARCH = 'contains' as const;
export const QUERY_PARAM_STATUS = 'status' as const;
export const QUERY_PARAM_ORDER_DIRECTION = 'orderDirection' as const;
export const QUERY_PARAM_ORDER_FIELD = 'orderField' as const;
export const NAME = 'NAME' as const;
export const RELEASE_DATE = 'RELEASE_DATE' as const;
export const START_DATE = 'START_DATE' as const;
export const DESCRIPTION = 'DESCRIPTION' as const;
export const SEQUENCE = 'SEQUENCE' as const;
export const PAGINATION_SIZE = 20;
export const NUM_SUPPORTD_STATUSES = 3;

export const RELEASED = 'RELEASED' as const;
export const UNRELEASED = 'UNRELEASED' as const;
export const ARCHIVED = 'ARCHIVED' as const;

export const PROJECT_VERSIONS_ANALYTICS_SOURCE = 'projectVersions';
